// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const navConfig = [
  {
    title: 'dashboard',
    path: '/dashboard/app',
    icon: icon('ic_analytics'),
  },
  {
    title: 'girls',
    path: '/dashboard/girls',
    icon: icon('ic_user'),
  },
  {
    title: 'affiliates',
    path: '/dashboard/affiliates',
    icon: icon('ic_user'),
  },
  {
    title: 'photogrpahers',
    path: '/dashboard/photographers',
    icon: icon('ic_user'),
  },
  {
    title: 'withdrawal List',
    path: '/dashboard/withdrawalList',
    icon: icon('ic_user'),
  },
  {
    title: 'partner',
    path: '/dashboard/partner',
    icon: icon('ic_user'),
  },
  // {
  //   title: 'blog',
  //   path: '/dashboard/blog',
  //   icon: icon('ic_blog'),
  // },
  // {
  //   title: 'login',
  //   path: '/login',
  //   icon: icon('ic_lock'),
  // },
  // {
  //   title: 'Not found',
  //   path: '/404',
  //   icon: icon('ic_disabled'),
  // },
];

export default navConfig;
